import { Tooltip, TooltipProps } from '@fluentui/react-components';
import { FC, useState } from 'react';

interface TProps extends TooltipProps {
  enable?: boolean;
}

// only shows tooltip if enabled and content is not equal ''
const ControlledTooltip: FC<TProps> = ({ enable = true, ...props }) => {
  const [isVisibleTooltip, setIsVisibleTooltip] = useState(false);

  return (
    <Tooltip
      visible={isVisibleTooltip && enable && Boolean(props.content)}
      onVisibleChange={(_ev, data) => {
        // Ignore events while disabled; stale `true` captured under enable=false would surface when enable flips true.
        if (enable) setIsVisibleTooltip(data.visible);
      }}
      {...props}
    />
  );
};

export { ControlledTooltip };
